import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";

const styles = {
  iframe: {
    width: "100%",
    height: "850px",
    border: "0",
    // ...boxShadow,
  },
  iframeContainer: {
    margin: "0 -20px 0",
  },
};

const LawBase = ({ classes }) => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={6}>
        <Typography
          component="div"
          style={{
            backgroundColor: "white",
            marginTop: "10px",
            marginLeft: "25px",
            zIndex: 9999,
          }}
        >
          <iframe
            className={classes.iframe}
            src="https://zakon.rada.gov.ua/laws/show/375-17"
            title="law"
          >
            <p>Your browser does not support iframes.</p>
          </iframe>
        </Typography>
      </Grid>

      <Grid item xs={12} md={6}>
        <Typography
          component="div"
          style={{
            backgroundColor: "white",
            marginTop: "10px",
            marginRight: "25px",
          }}
        >
          <iframe
            className={classes.iframe}
            src="https://zakon.rada.gov.ua/laws/show/580-2019-%D0%BF?lang=uk"
            title="law"
          >
            <p>Your browser does not support iframes.</p>
          </iframe>
        </Typography>
      </Grid>
    </Grid>
  );
};

export default withStyles(styles)(LawBase);
